
import { columnType } from "./column-type.enum";

// These are separate section types, but the same name can mean different geometry, 
// because G-MBG for example can be in plinth and on the roof and while being on the roof makes it have different 3D shape and model

export const columnBays = [
    {
        type: columnType.H_S,
        bays: 1
    },
    {
        type: columnType.H_L,
        bays: 2
    },
    {
        type: columnType.H_M1M2,
        bays: 3
    },
]
